import { useTranslation } from 'react-i18next'
import { Button } from '~/components/ui/button'

type TablePaginationProps = {
  page: number
  pageSize: number
  /** Nombre total de lignes côté serveur, tous écrans de pagination confondus. */
  total?: number | null
  onPageChange: (page: number) => void
}

/**
 * Pied de tableau paginé : compteur de résultats + précédent/suivant.
 * Partagé par les tableaux du back-office qui pilotent leur pagination avec
 * `useTableQuery`.
 */
function TablePagination({ page, pageSize, total, onPageChange }: TablePaginationProps) {
  const { t } = useTranslation()

  return (
    <div className="flex items-center justify-end space-x-2 py-4">
      <div className="flex-1 text-sm text-muted-foreground">
        {`${total ?? 0} ${t('common.results')}`}
      </div>
      <div className="space-x-2">
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(Math.max(page - 1, 1))}
          disabled={page === 1}
        >
          {t('common.previous')}
        </Button>
        <Button
          variant="outline"
          size="sm"
          onClick={() => onPageChange(page + 1)}
          disabled={!!(total && page * pageSize >= total)}
        >
          {t('common.next')}
        </Button>
      </div>
    </div>
  )
}

export default TablePagination
